import { ReactNode } from 'react';
import { UnstyledButton } from '@mantine/core';
import Workspace from 'src/entities/workspace';
import SubscriptionPlanSelectionModal from '../../modals/SubscriptionPlanSelectionModal/SubscriptionPlanSelectionModal';
import useFeaturePaywall from './useFeaturePaywall';

export type FeaturePaywallRenderParams = {
	planName: string;
	paywallMessage: string;
	isFeatureAvailable: boolean;
};

type FeaturePaywallProps = {
	feature: string;
	workspace: Workspace;
	stackOrder?: number;
	origin?: string;
	children?: ( params: FeaturePaywallRenderParams ) => ReactNode;
};

const FeaturePaywall = ( {
	feature, workspace, stackOrder = 1, origin, children
}: FeaturePaywallProps ) => {
	const {
		planButtonStyles,
		planWithRequiredFeature,
		shouldDisableActions,
		isShowingSubscriptionPlanSelectionModal,
		onRequiredPlanClick,
		onSubscriptionPlanSelectionModalClose,
		paywallMessage,
		isFeatureAvailable
	} = useFeaturePaywall( { feature, workspace, origin } );

	if ( !planWithRequiredFeature ) return null;

	return (
		<>
			<UnstyledButton
				onClick={onRequiredPlanClick}
				style={planButtonStyles}
				disabled={shouldDisableActions}
				aria-label={isFeatureAvailable ? `Upgrade to ${planWithRequiredFeature.name}` : undefined}
				data-testid="feature-paywall-wrapper"
			>
				{children?.( {
					planName: planWithRequiredFeature.name,
					paywallMessage,
					isFeatureAvailable
				} )}
			</UnstyledButton>

			{isShowingSubscriptionPlanSelectionModal && (
				<SubscriptionPlanSelectionModal
					stackOrder={stackOrder}
					onClose={onSubscriptionPlanSelectionModalClose}
				/>
			)}
		</>
	);
};

export default FeaturePaywall;
